angular.module('messenger')
  .component('onswMessageNotification', {
    template: `<div ng-show="amateur" ng-click="click()" class="box" ons-icon="::chat">
                <span style="float:right" ons-icon="::close" ng-click="remove($event)"></span>
                <span class="text" translate="messenger.messageReceived" translate-value-sender="{{amateur.getNickname()}}"></span>
              </div>`,
    controller: ['$scope', '$element', 'sock', 'messenger', '$timeout', 'Amateur', '$injector', ($scope, $element, sock, messenger, $timeout, Amateur, $injector) => {
      let timer = null;
      $scope.amateur = null;

      $element.addClass('ons-text');

      sock.registerHandler('message.received', msg => {

        if ($injector.has('Livecam') && $injector.get('Livecam').isActive()) {
          return;
        }

        if ($injector.has('Hotornot') && $injector.get('Hotornot').isActive()) {
          return;
        }

        $timeout.cancel(timer);

        Amateur.get(msg.sender)
          .then(amateur => {
            $scope.amateur = amateur;
            timer = $timeout($scope.remove, 20000);
            angular.element('body').addClass('message-notification-open');
          });
      });

      $scope.click = () => {
        let dialog = messenger.get($scope.amateur.id);
        dialog.show();
        $scope.remove();
      };

      $scope.remove = (ev = null) => {
        if (ev) {
          ev.stopPropagation();
        }
        $scope.amateur = null;
        angular.element('body').removeClass('message-notification-open');
      };
    }]

  });
